import api from '../apiService';

export const getCurrentUser = () => api.get('/get-current-user-details');